import { useEffect, useRef } from "react";

function preloadImage(entry) {
  entry.target.src = entry.target.dataset.src;
  entry.target.removeAttribute("data-src");
}

export function useImageIntersectionObserver(containerRef) {
  const observer = useRef(null);

  useEffect(() => {
    console.log(containerRef);
    if (!containerRef?.current) return;

    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const computedStyle = window.getComputedStyle(entry.target);
          if (
            entry.isIntersecting &&
            computedStyle.visibility !== "hidden" &&
            computedStyle.display !== "none" &&
            computedStyle.opacity !== "0" &&
            entry.target.dataset?.src
          ) {
            //load image
            preloadImage(entry);
            observer.current?.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "50px 0px 50px 0px" }
    );

    const imgs = containerRef.current.querySelectorAll("img[data-src]");
    imgs.forEach((img) => observer.current?.observe(img));

    return () => observer.current?.disconnect();
  }, [containerRef]);

  useEffect(() => {
    if (!containerRef?.current) return;

    const observeNewImages = (mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.tagName === "IMG" && node.hasAttribute("data-src")) {
            observer.current?.observe(node);
          } else {
            // If node is a container, find nested images
            const nestedImgs = node.querySelectorAll?.("img[data-src]") || [];
            nestedImgs.forEach((img) => observer.current?.observe(img));
          }
        });
      });
    };

    const mo = new MutationObserver(observeNewImages);
    mo.observe(containerRef.current, { childList: true, subtree: true });

    return () => mo.disconnect();
  }, [containerRef]);

  return observer;
}
